import { Link } from "react-router-dom";
import { Column, Grid, IconButton } from "@carbon/react";

import warningIcon from "../../assets/icons/warning.svg";
// import closeIcon from "../../assets/icons/close.svg";

export const View = ({
  title,
  subtitle,
  urlTarget,
  icon = warningIcon,
  statusColor,
  showOnboardingRequired = false,
}) => {
  return (
    <div
      className={`activation-required ${statusColor} ${
        showOnboardingRequired ? "" : "hidden"
      }`}
    >
      {/* <div className="close-button--container">
        <IconButton
          label="Close"
          size="sm"
          kind="tertiary"
          className="switchapp-themed close-button"
        >
          <img src={closeIcon} alt="close icon" className="close-icon" />
        </IconButton>
      </div> */}

      <Link to={urlTarget} className="activation-required--link">
        <div className="flex-container activation-required--message">
          {!icon ? (
            <></>
          ) : (
            <div className="activation-required--icon">
              <img src={icon} alt="warning icon" className="warning-icon" />
            </div>
          )}

          <div className="flex-box">
            <h4 className="activation-required--title font-ctm--bold">
              <strong>{title}</strong>
            </h4>

            <p className="activation-required--subtitle">{subtitle}</p>
          </div>
        </div>
      </Link>
    </div>
  );
};
